module.exports = __webpack_public_path__ + "img/station-img_2.ab60c843.png";